import { IconInfoRegular, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

interface Props {
  text: string;
}

export const StoreDeal: React.FC<Props> = ({ text }) => {
  return (
    <StoreDealWrapper>
      <IconWrapper>
        <IconInfoRegular width={18} height={18} color='textSecondary' />
      </IconWrapper>
      <Text variant='Body_13_Regular' color='textSecondary' style={{ wordBreak: 'keep-all', lineHeight: '150%' }}>
        {text}
      </Text>
    </StoreDealWrapper>
  );
};

const StoreDealWrapper = styled.div`
  display: flex;
`;

const IconWrapper = styled.div`
  margin-right: 2px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 19.5px;
`;
